import {decodeTrailerText} from "@/requesters/utils";

const getters = {
    currentView(state) {
        return state.currentView;
    },
    transactionId(state) {
        return state.transactionId;
    },
    messageDateTime(state) {
        return state.messageDateTime;
    },
    version(state) {
        return state.version;
    },
    anonymized(state) {
        return state.anonymized;
    },
    showVersionWarning(state) {
        return state.messageDateTime != null || state.version != null;
    },
    poslogApi(state) {
        return state.poslogApi;
    },
    xml(state) {
        return state.xml;
    },
    json(state) {
        return state.poslogApi ?
            JSON.stringify(state.poslogApi.poslog, undefined, 2) : "";
    },
    receipt(state) {
        return state.poslogApi ?
            decodeTrailerText(state.poslogApi.poslog.transaction.trailerText) : "";
    },
    content(state, getters) {
        if (state.currentView == 'xml') return getters.xml;
        if (state.currentView == 'json') return getters.json;
        if (state.currentView == 'receipt') return getters.receipt;

        return "No data";
    },
    lang(state) {
        return state.lang;
    },
    downloadMeta(state) {
        return state.downloadMeta;
    },
    history(state) {
        return state.history;
    }
};

export default getters;
